module.exports = __webpack_public_path__ + "static/media/tjt_mtm.9fbd97f2.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/montemar/img/tjt_mtm.png
 ** module id = 472
 ** module chunks = 0
 **/